import { ITheme } from '@fluentui/react/lib/Styling';
import { ICustomizations } from '@fluentui/react/lib/Utilities';
import { backgroundNames, ThemeNames } from '../teams-theme-types';
import { getBreadcrumbStyles } from './styles/breadcrumb.styles';
import { getCalloutContentStyles } from './styles/callout.styles';
import { getCheckboxStyles } from './styles/checkbox.styles';
import { getChoiceGroupOptionStyles } from './styles/choice-group-option.styles';
import { getComboBoxStyles } from './styles/combo-box.styles';
import { CommandBarButtonStyles } from './styles/command-bar-button.styles';
import { getCommandBarStyles } from './styles/command-bar.styles';
import { getContextualMenuStyles } from './styles/contextual-menu.styles';
import { getDatePickerStyles } from './styles/date-picker.styles';
import { getDefaultButtonStyles } from './styles/default-button.styles';
import {
  getCheckStyles,
  getDetailsListStyles,
  getDetailsRowStyles
} from './styles/details-list.styles';
import {
  getDialogContentStyles,
  getDialogFooterStyles
} from './styles/dialog.styles';
import { getDropdownStyles } from './styles/dropdown.styles';
import { LabelStyles } from './styles/label.styles';
import { getMessageBarStyles } from './styles/message-bar.styles';
import { getModalStyles } from './styles/modal.styles';
import { getPanelStyles } from './styles/panel.styles';
import { getPersonaStyles } from './styles/persona.styles';
import { getPivotStyles } from './styles/pivot.styles';
import { getPrimaryButtonStyles } from './styles/primary-button.styles';
import { getScrollablePaneStyles } from './styles/scrollable-pane.styles';
import { getSearchBoxStyles } from './styles/search-box.styles';
import { getTextFieldStyles } from './styles/text-field.styles';
import { getToggleStyles } from './styles/toggle.styles';
import { getTooltipStyles } from './styles/tooltip.styles';
import { getLinkStyles } from './styles/link.styles';

export function getTeamStyles(
  themeName: ThemeNames,
  theme: ITheme,
  background?: backgroundNames
): ICustomizations['scopedSettings'] {
  return {
    Breadcrumb: {
      styles: getBreadcrumbStyles(themeName, theme)
    },
    CalloutContent: {
      styles: getCalloutContentStyles(themeName, theme)
    },
    ContextualMenu: {
      styles: getContextualMenuStyles(themeName, theme)
    },
    DatePicker: {
      styles: getDatePickerStyles(themeName, theme)
    },
    Check: {
      styles: getCheckStyles(themeName, theme)
    },
    Checkbox: {
      styles: getCheckboxStyles(themeName, theme)
    },
    ChoiceGroupOption: {
      styles: getChoiceGroupOptionStyles(themeName, theme)
    },
    ComboBox: {
      styles: getComboBoxStyles(themeName, theme, background)
    },
    CommandBar: {
      styles: getCommandBarStyles(themeName, theme)
    },
    CommandBarButton: {
      styles: CommandBarButtonStyles
    },
    DefaultButton: {
      styles: getDefaultButtonStyles(themeName, theme)
    },
    DetailsRow: {
      styles: getDetailsRowStyles(themeName, theme)
    },
    DetailsList: {
      styles: getDetailsListStyles(themeName, theme)
    },
    Dropdown: {
      styles: getDropdownStyles(themeName, theme)
    },
    PrimaryButton: {
      styles: getPrimaryButtonStyles(themeName, theme)
    },
    Pivot: {
      styles: getPivotStyles(themeName, theme)
    },
    Modal: {
      styles: getModalStyles(themeName, theme)
    },
    MessageBar: {
      styles: getMessageBarStyles(themeName, theme)
    },
    Label: {
      styles: LabelStyles
    },
    DialogContent: {
      styles: getDialogContentStyles(themeName, theme)
    },
    DialogFooter: {
      styles: getDialogFooterStyles(themeName, theme)
    },
    TextField: {
      styles: getTextFieldStyles(themeName, theme, background)
    },
    Tooltip: {
      styles: getTooltipStyles(themeName, theme)
    },
    Panel: {
      styles: getPanelStyles(themeName, theme)
    },
    Persona: {
      styles: getPersonaStyles(themeName, theme)
    },
    Toggle: {
      styles: getToggleStyles(themeName, theme, background)
    },
    ScrollablePane: {
      styles: getScrollablePaneStyles(themeName, theme)
    },
    SearchBox: {
      styles: getSearchBoxStyles(themeName, theme)
    },
    Link: {
      styles: getLinkStyles(themeName, theme)
    }
  };
}
